import React from 'react'
import styled from 'styled-components';
import { CalendarContainer } from 'react-datepicker';

const ContainerWrapper = styled.div`
    font-family: "Helvetica Neue", Helvetica, Arial, sans-serif;
    font-size: 0.8rem;
    background-color: #fff;
    color: #000;
    border: 1px solid #aeaeae;
    border-radius: 0.3rem;
    display: inline-block;
    position: relative;
    .react-datepicker__navigation {
        background: none;
        border: 0.45rem solid transparent;
    }

    .react-datepicker__navigation--previous {
        border-right-color: #8f8f8f;
    }

    .react-datepicker__navigation--previous:hover {
        background: none;
        border: 0.45rem solid transparent;
        border-right-color: #424242;
    }

    .react-datepicker__navigation--previous:focus:hover {
        background: none;
        border: 0.45rem solid transparent;
        border-right-color: #424242;
    }

    button.react-datepicker__navigation--previous:focus {
        background: none;
        border: 0.45rem solid transparent;
        border-right-color: #8f8f8f;
    }

    button.react-datepicker__navigation--previous:not(:disabled):not(.disabled):active:focus {
        background: none;
        border: 0.45rem solid transparent;
        border-right-color: #424242;
    }

    .react-datepicker__navigation--next {
        background: none;
        border: 0.45rem solid transparent;
        border-left-color: #8f8f8f;
    }

    .react-datepicker__navigation--next:hover {
        background: none;
        border: 0.45rem solid transparent;
        border-left-color: #424242;
    }

    .react-datepicker__navigation--next:focus:hover {
        background: none;
        border: 0.45rem solid transparent;
        border-left-color: #424242;
    }
    
    button.react-datepicker__navigation--next:focus {
        background: none;
        border: 0.45rem solid transparent;
        border-left-color: #8f8f8f;
    }
    
    button.react-datepicker__navigation--next:not(:disabled):not(.disabled):active:focus {
        background: none;
        border: 0.45rem solid transparent;
        border-left-color: #424242;
    }
`

const ContainerTitle = styled.div`
    text-align: center;
    background-color: #f0f0f0;
`

const ContainerCalendar = styled.div`
`

interface DateTimePickerContainerProps {
    title?: string
}

const DateTimePickerContainer: React.FC<DateTimePickerContainerProps> = ({ title, children }) => {
    return (
        <ContainerWrapper>
            <CalendarContainer>
                <ContainerTitle>
                    {title}
                </ContainerTitle>
                <ContainerCalendar>{children}</ContainerCalendar>
            </CalendarContainer>
        </ContainerWrapper>
    );
};

export default DateTimePickerContainer